// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ViewIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ViewIcon" ref={forwardedRef} {...props}>
      <path d="M10.5 9.25a1.25 1.25 0 0 1 1.026-1.23 2.5 2.5 0 1 0 .96 2.24A1.25 1.25 0 0 1 10.5 9.25" />
      <path d="M18 10c-1.5-3.359-4.686-6-8-6s-6.5 3-8.002 6C3.5 13 6.687 16 10 16s6.5-3 8-6m-4.26 2.956C12.51 13.946 11.206 14.5 10 14.5s-2.509-.553-3.74-1.544A11.3 11.3 0 0 1 3.708 10 11.3 11.3 0 0 1 6.26 7.044C7.49 6.054 8.794 5.5 10 5.5c2.352 0 4.884 1.805 6.312 4.464a11.3 11.3 0 0 1-2.572 2.992" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ViewIcon = /* @__PURE__ */ Object.assign(ViewIconComponent, {
  displayName: 'ViewIcon',
});
